import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button, Label,
    Spinner,
    Progress,
    Table,
    TabContent, TabPane, Nav, NavItem, NavLink, CardText
} from "reactstrap"
import classnames from 'classnames'
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import Select from '../../../../../helpers/ui/CustomSelect'
import { AvForm, AvField, AvGroup, AvCheckboxGroup, AvCheckbox, AvInput } from "availity-reactstrap-validation"
import CustomSelect from '../../../../../helpers/ui/CustomSelect'
import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../../Index/Blocs/IndexBloc'
import DetailBloc from '../Blocs/DetailBloc'
import { combineAll } from 'rxjs/operators'

class TeknisComponent extends Component {

    detailBloc = new DetailBloc()
    indexBloc = new IndexBloc()
    source
    timer
    constructor(props) {
        super(props)
        this.state = {
            detail: [],
            detailstankom: [
                {
                    competence: '',
                    competencename:'',
                    levelname:'',
                    level: 0,
                }
            ],
            kompetensilist: [
                {
                    kompetensiuuid: '',
                    kompetensiname:'',
                }
            ],
            kompetensilevel: [
                {
                    level: '',
                    levelname:'',
                }
            ],
            list: [],
            dataForm: {},
            isLoading: 0,
        }
    }

    addStankom = () => {
        let count = this.state.detailstankom.length;
        this.setState({
            detailstankom: [
                ...this.state.detailstankom,
                {
                    competence : count == 0 ? (count+1) : this.state.detailstankom.slice(-1)[0].competence,
                    competencename : count == 0 ? (count+1) : this.state.detailstankom.slice(-1)[0].competencename,
                    level : count == 0 ? (count+1) : this.state.detailstankom.slice(-1)[0].level,
                    levelname : count == 0 ? (count+1) : this.state.detailstankom.slice(-1)[0].levelname
                }
            ]
        })

        // console.log(this.state.detailstankom)
    }

    delStankom = (data) => {
        let count = this.state.detailstankom.length-1;
        this.setState({
            detailstankom: [
                ...this.state.detailstankom.filter((val) => val!=data)
                
                // (count-1)
            ]
        })
    }

    reformatStankom = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["competence"] = data.stancom_competence_uuid;
          newObj["competencename"] = data.competence_name;
          newObj["level"] = data.stancom_competence_level;
          newObj["levelname"] = data.level_name;
      
          return newObj;
        });
    }
    reformatLevel = (raw) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = `Level-${data.level_no}-${data.level_name}`;
          newObj["value"] = data.level_id;
      
          return newObj;
        });
    }

    reformatOptions = function(raw, label, value) {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
      };

    handleChangeInputStankom = (e, index) => {
        // 1. Make a shallow copy of the items
        let items = [...this.state.detailstankom];
        // 2. Make a shallow copy of the item you want to mutate
        let item = {...items[index]};
        // 3. Replace the property you're intested in
        item.name = e.target.value;
        // 4. Put it back into our array. N.B. we *are* mutating the array here, but that's why we made a copy first
        items[index] = item;
        // 5. Set the state to our new copy
        this.setState({detailstankom : items});
    }

    toggle = tab => {
        if(this.state.activeTab !== tab) this.setState({activeTab:tab});
    }

    submitData = async () => {
        await this.detailBloc.fetchUpdate(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.uuid
        }

        await this.indexBloc.fetchDetail(query)
    }

    loadDetailStankom = async () => {
        const query = {
            uuid: this.props.uuid,
            type: 2
        }

        await this.detailBloc.fetchDetailStankom(query)
    }
    loadKompetensi = async () => {
        const query = {
            uuid: this.props.uuid,
            type: 2
        }

        await this.detailBloc.fetchKompetensiList(query)
    }

    handleChangeCompetence = async (e, index) => {

        const query = {
            uuid: e.value,
            // type: 1
        }

        // console.log(e.value)
        
        await this.detailBloc.fetchKompetensiLevel(query)
    }

    handlerOnSubmitManajerial = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                position_uuid: this.props.uuid,
                ...values
            },
            confirm: true
        })
    }

    componentDidMount() {

        this.loadDetail()
        this.loadDetailStankom()
        this.loadKompetensi()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
        this.detailBloc.detailStankomChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let resp = result.data.response;
                    // console.log('---------')
                    // console.log(resp)
                    // console.log('---------')

                    if (resp.length > 0){
                        this.setState({ 
                            detailstankom : this.reformatStankom(resp)
                        })
                    }

                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })
        this.detailBloc.kompetensiChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let resp = result.data.response;

                    // console.log(resp)

                    this.setState({
                        kompetensilist : this.reformatOptions(
                            resp, 
                            'competence_name',
                            'competence_uuid'
                        )
                    })

                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.detailBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.detailBloc.kompetensiLevelChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    let resp = result.data.response;
                    
                    //console.log(resp)
                    
                    this.setState({
                        kompetensilevel : this.reformatLevel(resp)
                    })
                        
                break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

    }

    componentWillUnmount() {
        this.indexBloc.detailChannel?.unsubscribe()
        this.indexBloc.updateChannel?.unsubscribe()
    }

    render() {
        const { detail, list } = this.state
        const { result, total } = list
       
        return (
            <Fragment>
                <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) => this.handlerOnSubmitManajerial(e, values)}
                >
                    <Col md="12">
                            <div className="row" style={{padding:'15px'}}>
                                <div className="col-md-5 text-bold">
                                    <b>Standar Kompetensi Teknis</b>
                                </div>
                            </div>
                        </Col>
                    <Row className="mb-12">
                        <AvField
                            name="tipe"
                            type="hidden"
                            id="tipe"
                            value="2"
                        />
                        <AvField
                            name="position_uuid"
                            type="hidden"
                            value={detail?.position_uuid}
                            validate={{ required: { value: true } }}
                            readOnly={true}
                        />
                        <Col md="12">
                        <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>No.</th>
                                        <th>Kompetensi</th>
                                        <th>Tingkat Kemahiran</th>
                                    </tr>  
                                </thead>
                                <tbody>
                            {
                                this.state.detailstankom.map((data, index) => {
                                    return (
                                        <tr>
                                            <td>{(index+1)}</td>
                                            <td>{data.competencename}</td>
                                            <td>{'Level - '+data.level+'. '+data.levelname}</td>
                                        </tr>
                                    )    
                                })
                            }
                                </tbody>
                            </table>
                            
                        </Col>
                    </Row><br /><br />
                    <Row className="mb-3" style={{padding:'25px'}}>
                        <Col md="3"></Col>
                        <Col md="9">
                            <Link to="/master/standar_kompetensi.html">
                                <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                            </Link>
                            {' '}
                            
                        </Col>
                    </Row>
                </AvForm>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/standar_kompetensi.html'/>
                : null }
            </Fragment>
        )
    }


}

export default TeknisComponent
